import axios from "axios";
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import { Header } from "../../components/Header";
import { TopicCard } from "../../components/TopicCard";
import { mergeWithStatus, mergeWithTopics } from "./utils";
import { API_URL } from "../../constants";

import { ProgressWithContentType } from "./StudentBoard.type";

import './StudentBoard.styles.scss';

export const StudentBoard: React.FC<any> = ({ user }) => {
  const [isAuth, setAuth] = useState<boolean>();
  const [userId, setUserId] = useState<string>('');
  const [error, setError] = useState(null);
  const [progressData, setProgressData] = useState<any>();
  const [studentData, setStudentData] = useState<ProgressWithContentType>();
  const [curriculumStatusData, setCurriculumStatusData] = useState<any>();
  const navigate = useNavigate();
  // const [ studentProgress, setStudentProgress } = useContext(StudentContext)

  useEffect(() => {
    const fetchData = async () => {
      try {
        // First request: get auth and userId
        const response = await axios.get(`${API_URL}/river-map`, {
          withCredentials: true,
        });
        const { auth, userId } = response.data;
        setAuth(auth);
        setUserId(userId);

        if (auth && !!userId.length) {
          // Second request: get student progress by userId
          const studentProgress = await axios.get(`${API_URL}/getStudentProgressById/${userId}`, {
            withCredentials: true,
          });

          setProgressData(studentProgress.data);
          const { curriculum_id } = studentProgress.data;

          // Third request: get curriculum status by curriculum_id
          const curriculumStatus = await axios.get(`${API_URL}/getCurriculumStatusById/${curriculum_id}`, {
            withCredentials: true,
          });
          setCurriculumStatusData(curriculumStatus.data);

        }
      } catch (e: any) {
        setError(e.response?.data?.message || e.message);
        if (e?.status === 401 || e?.response?.status === 401) {
          navigate("/");
        }
      }
    };

    if (!progressData && !curriculumStatusData) {
      fetchData();
    }
  }, []);

  const fetchTopics = async () => {
    try {
      const response = await axios.get(`${API_URL}/getCurriculumTopics`, {
        withCredentials: true,
      });
      console.log('getCurriculumTopics', response.data)

      return response.data;
    } catch (err: any) {
      setError(err.response?.data?.message || err.message);
    }
  };


  const fetchAndMerge = async () => {
    const progressWithStatuses = mergeWithStatus({
      studentProgress: progressData,
      curriculumStatus: curriculumStatusData
    });
    console.log('progressWithStatuses', progressWithStatuses);
    const topicsData = await fetchTopics();
    console.log('topicsData', topicsData);

    const progressWithStatusesAndContent = mergeWithTopics({
      studentProgress: progressWithStatuses,
      topicsList: topicsData
    });
    console.log('progressWithStatusesAndContent', progressWithStatusesAndContent);
    setStudentData(progressWithStatusesAndContent);
    // setStudentProgress(progressWithStatusesAndContent);
  }

  useEffect(() => {
    console.log('progressData', progressData)
    console.log('curriculumStatusData', curriculumStatusData)


    if (progressData?.topics?.length && curriculumStatusData?.topics?.length) {
      fetchAndMerge();
    }
  }, [progressData, curriculumStatusData])

  useEffect(() => {
    const handleBeforeUnload = (event: PopStateEvent) => {
      // Redirect user or handle logic instead of allowing to go back
      navigate('/', { replace: true });
      event.preventDefault();
    };

    window.addEventListener('popstate', handleBeforeUnload);

    return () => window.removeEventListener('popstate', handleBeforeUnload); // Cleanup
  }, [navigate]);

  if (error) return <div>Error: {error}</div>;
  if (!isAuth) return <div>Loading...</div>;
  if (userId) console.log('userId', userId)
  // if (!isAuth) {
  //   navigate(-1);
  //   return null;
  // }

  return (
    <>
      <Header home={true} logOut={true} />
      <main className="LandingContainer StudentBoard">
        {!!user && <span>{user.name}</span>}
        {studentData?.topics?.map(card =>
          <TopicCard
            isUnlocked={card.active}
            redirectPath={card.redirect_link}
            imagePath={card.image_path}
            imageAlt={''}
            lessons={card.circles}
          />
        )}
      </main>
    </>
  );
};
